require("core-js/modules/esnext.global-this.js");
(function (a, b) {
  if ("function" == typeof define && define.amd) define(["exports"], b);else if ("undefined" != typeof exports) b(exports);else {
    var c = {
      exports: {}
    };
    b(c.exports), a.unknown = c.exports;
  }
})("undefined" == typeof globalThis ? "undefined" == typeof self ? this : self : globalThis, function (a) {
  "use strict";

  function b(a, b) {
    return g(a) || f(a, b) || d(a, b) || c();
  }
  function c() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function d(a, b) {
    if (a) {
      if ("string" == typeof a) return e(a, b);
      var c = Object.prototype.toString.call(a).slice(8, -1);
      return "Object" === c && a.constructor && (c = a.constructor.name), "Map" === c || "Set" === c ? Array.from(a) : "Arguments" === c || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(c) ? e(a, b) : void 0;
    }
  }
  function e(a, b) {
    (null == b || b > a.length) && (b = a.length);
    for (var c = 0, d = Array(b); c < b; c++) d[c] = a[c];
    return d;
  }
  function f(a, b) {
    if ("undefined" != typeof Symbol && Symbol.iterator in Object(a)) {
      var c = [],
        d = !0,
        e = !1,
        f = void 0;
      try {
        for (var g, h = a[Symbol.iterator](); !(d = (g = h.next()).done) && (c.push(g.value), !(b && c.length === b)); d = !0);
      } catch (a) {
        e = !0, f = a;
      } finally {
        try {
          d || null == h["return"] || h["return"]();
        } finally {
          if (e) throw f;
        }
      }
      return c;
    }
  }
  function g(a) {
    if (Array.isArray(a)) return a;
  }
  function h() {
    throw "invalid media-query  :(";
  }
  function i() {
    throw "invalid breakpoint :(";
  } /**
    * get breakpoint list of css-in-js-media
    */
  function j() {
    return q;
  }
  function k(a) {
    var b = Object.keys(q),
      c = Object.keys(a);
    return c.every(function (a) {
      return b.includes(a);
    });
  } /**
    * set break points of css-in-js-media library with custom param
    * @param customizedBreakPoints customized breakpoint param
    */
  function l(a) {
    var b = k(a);
    return b ? void (q = Object.assign(Object.assign({}, q), a)) : i();
  } /**
    * use css in js media (ex: includeMedia(">=phone", "<tablet"))
    * @param query
    * @param betweenQuery
    */
  function m(a) {
    var c = n(a),
      d = b(c, 2),
      e = d[0],
      f = d[1],
      g = !!e && !!q[f];
    return g;
  }
  function n(a) {
    var b = a.match(r) ? a.match(r)[0].trim() : "",
      c = a.replace(r, "").trim();
    return [b, c];
  }
  function o(a, b) {
    return a.includes("=") ? q[b] : a.includes(">") ? q[b] + 1 : q[b] - 1;
  }
  function p(a) {
    var c = n(a),
      d = b(c, 2),
      e = d[0],
      f = d[1],
      g = o(e, f),
      h = "number" == typeof g ? "px" : "",
      i = e.includes(">") ? "min-width" : "max-width";
    return "(".concat(i, ": ").concat(g).concat(h, ")");
  }
  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.getBreakPoints = j, a.setBreakPoints = l, a["default"] = void 0;
  var q = {
      smallPhone: 320,
      phone: 375,
      tablet: 768,
      desktop: 1024,
      largeDesktop: 1440
    },
    r = /^[<=>]+/;
  a["default"] = function (a, b) {
    var c = b ? [a, b] : [a];
    return c.every(m) ? "@media ".concat(c.map(p).join(" and ")) : h();
  };
});